import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_TASK_STATISTICS: createActionType(FULL_NAMESPACE, "GET_TASK_STATISTICS"),
    GET_TASK_STATISTICS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_TASK_STATISTICS_COMPLETED"),
    SET_TASK_STATISTICS_FILTER_PARAMS: createActionType(FULL_NAMESPACE, "SET_TASK_STATISTICS_FILTER_PARAMS"),
    CLEAR_TASK_STATISTICS_FILTER_PARAMS: createActionType(FULL_NAMESPACE, "CLEAR_TASK_STATISTICS_FILTER_PARAMS"),
    CLEAR_ALL_TASK_STATISTICS_FILTER_PARAMS: createActionType(FULL_NAMESPACE, "CLEAR_ALL_TASK_STATISTICS_FILTER_PARAMS")
};
